import script from "./TestView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestView.vue?vue&type=script&setup=true&lang=ts"

import "./TestView.vue?vue&type=style&index=0&id=98e8367e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98e8367e"]])

export default __exports__